// First-party acquisition tracking: a durable visitor id, first/last-touch attribution,
// and helpers to carry UTM/partner/referral through signup. No PII; fire-and-forget.
import api from "@/lib/api";

const VID_KEY = "fv_vid";
const FIRST_KEY = "fv_attr_first";
const LAST_KEY = "fv_attr_last";

function uuid() {
  try { return crypto.randomUUID(); } catch (e) { return "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36); }
}

export function getVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) { v = "vid_" + uuid().replace(/-/g, "").slice(0, 20); localStorage.setItem(VID_KEY, v); }
    return v;
  } catch (e) { return "vid_anon"; }
}

function readParams() {
  const p = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: p.get("utm_source") || undefined,
    utm_medium: p.get("utm_medium") || undefined,
    utm_campaign: p.get("utm_campaign") || undefined,
    utm_term: p.get("utm_term") || undefined,
    utm_content: p.get("utm_content") || undefined,
    gclid: p.get("gclid") || undefined,
    partner: p.get("partner") || undefined,
    ref: p.get("ref") || undefined,
  };
  const source = utm.utm_source || (utm.partner ? "partner" : (utm.ref ? "referral" : (utm.gclid ? "google_ads" : "direct")));
  return { ...utm, source, landing: window.location.pathname, referrer: document.referrer || "" };
}

// Call once per public page load. Records the visit + persists first/last touch, and keeps
// partner/ref for signup (mirrors the existing fv_ref behavior).
export function captureTouch() {
  const visitor_id = getVisitorId();
  const t = readParams();
  try {
    if (!localStorage.getItem(FIRST_KEY)) localStorage.setItem(FIRST_KEY, JSON.stringify(t));
    localStorage.setItem(LAST_KEY, JSON.stringify(t));
    if (t.partner) localStorage.setItem("fv_partner", t.partner);
    if (t.ref) localStorage.setItem("fv_ref", t.ref);
  } catch (e) { /* ignore */ }
  api.post("/public/visit", { visitor_id, event: "visit", ...t }).catch(() => {});
}

// Attribution payload to send at signup / lead capture.
export function acqParams(extra = {}) {
  let first = {}, last = {};
  try { first = JSON.parse(localStorage.getItem(FIRST_KEY) || "{}"); } catch (e) { /* ignore */ }
  try { last = JSON.parse(localStorage.getItem(LAST_KEY) || "{}"); } catch (e) { /* ignore */ }
  let partner, ref;
  try { partner = localStorage.getItem("fv_partner") || undefined; ref = localStorage.getItem("fv_ref") || undefined; } catch (e) { /* ignore */ }
  const src = first.utm_source || last.utm_source || first.source;
  return {
    visitor_id: getVisitorId(),
    utm_source: first.utm_source || last.utm_source,
    utm_medium: first.utm_medium || last.utm_medium,
    utm_campaign: first.utm_campaign || last.utm_campaign,
    utm_term: first.utm_term,
    utm_content: first.utm_content,
    gclid: first.gclid || last.gclid,
    partner, ref, source: src, landing: first.landing,
    ...extra,
  };
}

// Most recent public free tool viewed in this browser (for tool → pricing/signup attribution).
export function lastTool() {
  try { return localStorage.getItem("fv_last_tool") || undefined; } catch (e) { return undefined; }
}

export function trackAcq(event, props = {}) {
  api.post("/public/track", { event, ...props, visitor_id: getVisitorId() }).catch(() => {});
}
